import { RestUrl } from "@/commons/constants/RestUrl";
import CommonService from "@/commons/services/CommonService";
import { AxiosResponse } from "axios";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * システム設定 API 操作クラス
 */
export default class SystemSettings {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET SystemSetting
   */
  public async getSystemSetting(): Promise<SystemSetting> {
    const response: AxiosResponse<SystemSetting> = await this.commonService.executeSimpleGet(RestUrl.SystemSettings, this.constructor.name, null, HitomeqErrorType.REQUEST_RETRY);
    return response.data;
  }
}

/**
 * ### システム設定
 */
export interface SystemSetting {
  /** メンテナンス */
  maintenance: MaintenanceModel;
  /** アプリバージョン */
  version: string;
}

/**
 * ### メンテナンス情報
 */
export interface MaintenanceModel {
  /** ステータス */
  status: boolean;
  /** メンテナンス開始日時 */
  start: number;
  /** メンテナンス終了日時 */
  end: number;
}
